import React, { FunctionComponent } from 'react';
import { ItemsToSynchronizeList } from '../../synchronization/ItemsToSynchronizeList/ItemsToSynchronizeList';
import { prepareProps } from '../../utils/propUtils';
import {
  Side,
  SidebarWithBackdrop
} from '../SidebarWithBackdrop/SidebarWithBackdrop';
import styles from './SynchronizationStatusSidebar.module.css';

export type SynchronizationStatusSidebarProps = {
  opened: boolean;
  /**
   * this is called when something occured which wants to close the sidebar
   */
  onCloseSidebar: () => void;
  'data-testid'?: string;
};

export const SynchronizationStatusSidebar: FunctionComponent<SynchronizationStatusSidebarProps> =
  React.memo((props) => {
    const {
      opened,
      'data-testid': testid,
      onCloseSidebar
    } = prepareProps({ props, ignoreChildren: true });

    return (
      <SidebarWithBackdrop
        opened={opened}
        onCloseSidebar={onCloseSidebar}
        side={Side.Right}
        data-testid={testid}
      >
        <div className={styles.contentWrapper}>
          <ItemsToSynchronizeList></ItemsToSynchronizeList>
        </div>
      </SidebarWithBackdrop>
    );
  });
